/**
 * 
 * @returns 
 */
const Required = () => {
  return (
    <span className='text-destructive'>*</span>
  )
}

export default Required